import { useContext, useEffect, useState } from 'react';

import {
	ArrowLeftOutlined,
	HomeOutlined,
	LaptopOutlined,
	TeamOutlined,
	VideoCameraOutlined,
} from '@ant-design/icons';
import { Button, Flex, Radio, Tooltip, Typography } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';

import { CollectionContext } from '@/providers/CollectionsContextProvider';

import CreatorsCollections from './Creators';
import CreatorsGroupCollection from './Creators/CreatorsGroupCollection';
import VideosCollections from './Videos';
import VideosGroupCollection from './Videos/VideosGroupCollection';

export type TCollection =
	| 'videos'
	| 'creators'
	| 'monitor'
	| 'videos-group'
	| 'monitor-group'
	| 'creators-group';

export default function Collections() {
	const { setCollection, collection } = useContext(CollectionContext);
	const navigate = useNavigate();
	const params = useParams();

	useEffect(() => {
		if (['videos', 'creators'].includes((params?.type || '') as string)) {
			setCollection(
				params?.id ? `${params.type}-group` : (params.type as TCollection),
			);
		} else {
			navigate('/app/dashboard/video-insights-co-pilot/collections/videos');
			setCollection('videos');
		}

		return () => {
			setCollection('videos');
		};
	}, [params]);

	const RadioButtons = (
		<Flex
			vertical
			gap={8}
			align="flex-start"
			style={{ width: '100%', marginBottom: '1rem' }}
		>
			<Flex style={{ width: '100%' }} justify="space-between" align="center">
				<Typography.Title level={3} style={{ textAlign: 'left' }}>
					<strong>Copilot videos history - Collections</strong>
				</Typography.Title>

				<Button
					// size="small"
					onClick={() => {
						navigate('/app/dashboard/video-insights-co-pilot');
					}}
				>
					<ArrowLeftOutlined /> Back to Copilot Videos History
				</Button>
			</Flex>
			<Radio.Group
				value={collection}
				onChange={(e) => {
					navigate(
						`/app/dashboard/video-insights-co-pilot/collections/${e.target.value}`,
					);
					// setCollection(e.target.value as TCollection);
				}}
			>
				<Radio.Button
					value="videos"
					className={collection?.includes('videos') ? 'radio-checked' : ''}
				>
					<VideoCameraOutlined /> Videos
				</Radio.Button>
				<Radio.Button
					value="creators"
					className={collection?.includes('creators') ? 'radio-checked' : ''}
				>
					<TeamOutlined /> Creators
				</Radio.Button>
				{/* <Radio.Button
          value="monitor"
          className={collection?.includes("monitor") ? "radio-checked" : ""}
        >
          <LaptopOutlined /> Content-monitor
        </Radio.Button> */}
			</Radio.Group>
		</Flex>
	);

	const Components = (
		<>
			{RadioButtons}

			<VideosCollections />
			<CreatorsCollections />

			{/* secondary collections  */}
			<VideosGroupCollection />

			<CreatorsGroupCollection />

			{/* end secondary collections */}
		</>
	);

	return Components;
}
